import SIdentify from "../../untils/SIdentify/SIdentify";
import * as loginUtil from './api/LoginUtil'
import Vue from 'vue'
import ElementUI from 'element-ui';
import axios from 'axios'
Vue.use(ElementUI)

const expiringDate =  window.DEMO_EXPIRING_DATE || { 
  'simulation2022': new Date('2024-07-29').getTime(), 
  'demo': new Date('2025-07-19').getTime(),
}

export default {
  name: "Login",
  components: {
    SIdentify
  },
  data() {
    return {
      show: true,
      identifyCodes: "1234567890qweasdzxcrtyfghvbnuiojklm",
      identifyCode: "",

      /* login */
      selectTitleList: [
        { name: '登 录', id: '0', className: 'login' },
        { name: '注 册', id: '1', className: 'register' },
      ],
      selectTitleActive: '0',

      username: '',
      password: '',
      sidentify: '',

      verson: window.VERSON,

      // 轮播图
      loopImgList: [
        '/img/loop/1.png',
        '/img/loop/2.png',
        '/img/loop/3.png',
        '/img/loop/4.png',
        // '/img/loop/5.png',
        // '/img/loop/6.png',
        // '/img/loop/7.png',
        // '/img/loop/8.png',
        // '/img/loop/9.png',
        // '/img/loop/10.png',
        // '/img/loop/11.png',
        // '/img/loop/12.png',
        // '/img/loop/13.png',
        // '/img/loop/14.png',
      ],
      loopIdx: 0,

      explain: [
        {
          content: [
            '试运行阶段',
            '联系方式：陈经理 18068335587',
            '公司官网：<a class="address" href="http://www.enercomn.com" target="_blank">www.enercomn.com</a>',
          ],
        },
        {
          content: [
            Math.ceil((expiringDate['demo'] - new Date().getTime()) / 1000 / 3600 / 24) >= 1 ? '试用剩余时间: ' +  Math.ceil((expiringDate['demo'] - new Date().getTime()) / 1000 / 3600 / 24) + '天' : '试用剩余时间: 已到期',
            '试用账号: demo',
            '试用密码: Demo123',
          ],
        },
      ],
    };
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);

    this.loop()
  },
  methods: {

    loop () {
      this.loopInterval = setInterval(() => {
        this.loopIdx ++
        if (this.loopIdx >= this.loopImgList.length) this.loopIdx = 0

      }, window.LOOP_INTERVAL || 3000)
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    login() {
      let {
        username: cusername,
        password: cpassword,
      } = this

      let nowTime = new Date().getTime()
      let demoTime = expiringDate || {}

      if (nowTime >= demoTime['demo'] && cusername == 'demo') {
        this.$message({ message: '试用账号已到期', type: 'warning' })
        return
      }

      /* 自定义demo账号 */
      const { username, password } = window.DEMO_EXPIRING_USER || {}
      if (
        cusername == username &&
        cpassword == password
      ) {

        if (demoTime[username] > nowTime) {
          localStorage.setItem("enersum-appToken", 'demo');

          this.$store.commit('setUserInfo', { cusername })
  
          this.$router.push('/coldStation')

        }

        else {
          this.$message({
            type: 'warning',
            message: "该用户已过期, 请联系管理员",
          });
        }

        return
      }
      
      //客户端先验证验证码是否正确减小对服务器请求的开销
      if (this.sidentify !== this.identifyCode) {
        this.$message({
          title: "提示",
          message: "请输入正确验证码",
        });
        //判断用户名和密码是否为空
      } else if (cusername == "" && cpassword == "") {
        this.$message({
          title: "提示",
          message: "请输入用户名和密码",
        });
      } else if (cusername == "") {
        this.$message({
          title: "提示",
          message: "请输入用户名",
        });
      } else if (cpassword == "") {
        this.$message({
          title: "提示",
          message: "请输入密码",
        });
      } else {

        let params = { cusername, cpassword }
        //cusername: 是前后端商量好的参数 冒号后面的是变量名
        //将请求的参数传给loginPost方法，.then后面的是后台返回的数据
        axios.post( window.LOGIN_API + '/A01Login/selectUserInfo',params).then(data => {
          
          if (data.data.resultObject == -1) {
            this.$message({ message: '用户名错误', type: 'warning' })
          } else if (data.data.resultObject == -2) {
            this.$message({ message: '密码错误', type: 'warning' })
          } else {
            this.$message({ message: '登录成功',  type: 'success' })

            let d = data.data.resultObject

            let {
              userToken,
              cusername
            } = d

            localStorage.setItem("enersum-appToken", userToken);
           
            this.$store.commit('setUserInfo', { cusername })

            this.$router.push('/coldStation')

            this.recordLoginInfo()  // 记录登录
          }

        })
      }
    },

    recordLoginInfo () {
      this.$axios.post( window.LOGIN_API + '/A98SpecialAction/recordLoginInfo', {action: '登录'} )
    },

    keyLogin(e) {
      if( e.keyCode === 13 ) this.login()
    }
  }
};